import { Link as RouterLink } from '@tanstack/react-location';
import clsx from 'clsx';
import React from 'react';
import styles from '../css/buttons.module.scss';

type ButtonStyles = 'simple' | 'yellow' | 'green' | 'outline';

type LinkProps = {
  to: string;
  type: ButtonStyles;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  dataTestId?: string;
};

const Styles: Record<ButtonStyles, string> = {
  simple: styles.simpleLink,
  yellow: styles.buttonYellow,
  green: styles.buttonGreen,
  outline: styles.buttonOutlined,
};

const Link = React.memo(
  ({
    to,
    type,
    children,
    className = '',
    disabled = false,
    dataTestId,
  }: LinkProps): JSX.Element => {
    return (
      <RouterLink
        disabled={disabled}
        to={to}
        className={clsx(Styles[type], className)}
        data-testid={dataTestId}
      >
        {children}
      </RouterLink>
    );
  }
);

export default Link;
